/**
 * @overview 话题编辑
 * @author jzhu
 * @date 2020-9-8
 */

import React from 'react'
import moment from 'moment'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { createColumns } from './columns'
import { formatAuth } from '@/utils/commonUtils'

let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton } = component_tool
let { Session } = utils_tool

const getParamRecord = (history) => {
    let record = null
    if (history.location && history.location.pathname === '/community/topic/topicUpd') {
        if (history.location.record) {
            record = history.location.record
            Session.set('topicUpd', record)
        } else {
            record = Session.get('topicUpd') || {}
        }
    }
    return record
}

class TopicDetail extends WizContainer {

    componentName = 'TopicDetail'

    constructor(props) {
        super(props)
        let { history } = props
        let record = getParamRecord(history)
        this.state = {
            record,
            title: record && record.id ? '编辑话题' : '新增话题'
        }
    }

    _componentDidMount = () => {
        
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns col-item'>
                <WizCol span={24}>
                    <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
                    <WizButton title='重置' icon='reload' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _onSubmit = (values) => {
        let { id, date, icon, img, ...rest } = values
        let start = moment(date[0]).format('YYYY-MM-DD') + ' 00:00:00'
        let end = moment(date[1]).format('YYYY-MM-DD') + ' 23:59:59'
        if (icon && icon.length) {
            icon = icon[0].fileId
        }
        if (img && img.length) {
            img = img[0].fileId
        }

        const authInfo = formatAuth(values.authInfo)

        let apiParams = { ...rest, id, start, end, icon, img, authInfo }

        let action = id ? 'update' : 'create'
        
        this.doAction({
            path: 'topic/' + action,
            payload: {
                key: 'topic_save',
                apiParams
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('保存成功')
            this.jumpPage('push', '/community/topic')
        } else {
            wizNotice.error((nextProps.save && nextProps.save.msg) || '操作失败,请稍后尝试')
        }
        return true
    }

    _onReset = () => {
        this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    }
    _render() {
        let formProps = {
            ref: 'form',
            columns: createColumns(this, this.state.record),
            record: this.state.record,
            onSubmit: this._onSubmit,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <WizCard>
                <WizSpin tip={'加载中'} spinning={this.props.topicLoading}>
                    <WizForm className={'form-inline'} {...formProps} />
                </WizSpin>
            </WizCard>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { topic } = state
    const save = modelUtils.getModelEntity(topic, 'topic_save')
    const load = modelUtils.getLoadingState(state, 'topic')
    return {
        save,
        ...load
    }
}

export default connect(mapStateToProps)(TopicDetail)
